import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BootstrapSemanticVariation } from '@app/utils/bootstrap';
import { C5Helper } from '@app/utils/c5-helper';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'portal-modal-header',
  templateUrl: './modal-header.component.html',
  host: {
    class: 'modal-header',
  },
  standalone: false,
})
export class ModalHeaderComponent {
  @Input()
  entry?: any;

  @Input()
  i18nKey?: string;

  @Input()
  title?: string;

  @Input()
  variant?: BootstrapSemanticVariation;

  @Output()
  onClose: EventEmitter<void> = new EventEmitter();

  get genericTitle() {
    const isNew: boolean = C5Helper.isNew(this.entry);

    if (this.i18nKey != null) {
      return `${this.i18nKey}.${isNew ? 'add' : 'edit'}`;
    } else {
      return isNew ? 'generic.add.entry' : 'generic.edit.entry';
    }
  }

  emitClose() {
    this.onClose.emit();
  }
}
